export function initParallax() {
  const prlax = document.querySelector("[data-montagne]");
  const header = document.querySelector(".header");

  const originalY = parseInt(getComputedStyle(prlax).getPropertyValue("--bg-img-pos-y")) || 10;

  function updateBackground() {
    const pageHeight = document.documentElement.scrollHeight;
    const viewportHeight = window.innerHeight;
    const denominator = pageHeight - viewportHeight || 1; // Prevent division by zero
    const scrollProgress = Math.min(window.scrollY / denominator, 1);

    const behavior = getComputedStyle(document.body).getPropertyValue("--behavior").trim();

    if (behavior === "collapsed") {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const scrollThreshold = viewportHeight * 0.3;
      const mobileProgress = Math.min(scrollY / scrollThreshold, 1);
      const opacity = 0.1 + 0.9 * (1 - mobileProgress);
      const headerOpacity = Math.min(0 + mobileProgress, 1);
      prlax.style.setProperty("--scroll-opacity", opacity);
      header.style.setProperty("--header-opacity", headerOpacity);
      prlax.style.removeProperty("--bg-img-pos-y");
    } else {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const scrollThreshold = viewportHeight * 0.4;
      const mobileProgress = Math.min(scrollY / scrollThreshold, 1);
      const opacity = 0.2 + 0.8 * (1 - mobileProgress);
      const headerOpacity = Math.min(0 + mobileProgress, 1);
      prlax.style.setProperty("--scroll-opacity", opacity);
      header.style.setProperty("--header-opacity", headerOpacity);
      // Add speed limiting factor based on page height
      const speedFactor = Math.min(pageHeight / (viewportHeight * 20), 1);
      const maxY = 100;
      const newY = originalY + scrollProgress * (maxY - originalY) * speedFactor;

      if (!isNaN(newY)) {
        prlax.style.setProperty("--bg-img-pos-y", `${newY}%`);
      } else {
        console.warn("Invalid scroll calculation:", {
          originalY,
          scrollProgress,
          maxY,
          newY,
          speedFactor
        });
      }
      // prlax.style.removeProperty("--scroll-opacity");
    }
  }

  if (prlax) {
    ["scroll", "touchmove", "resize"].forEach(eventType => {
      window.addEventListener(eventType, updateBackground, { passive: true });
    });
  }
}
